import { useTranslation } from 'react-i18next';

const milestones = [
  { year: '2020', titleKey: 'milestone1_title', descKey: 'milestone1_desc', icon: 'ri-flag-line' },
  { year: '2021', titleKey: 'milestone2_title', descKey: 'milestone2_desc', icon: 'ri-building-2-line' },
  { year: '2022', titleKey: 'milestone3_title', descKey: 'milestone3_desc', icon: 'ri-global-line' },
  { year: '2023', titleKey: 'milestone4_title', descKey: 'milestone4_desc', icon: 'ri-lightbulb-line' },
  { year: '2024', titleKey: 'milestone5_title', descKey: 'milestone5_desc', icon: 'ri-star-line' },
  { year: '2025', titleKey: 'milestone6_title', descKey: 'milestone6_desc', icon: 'ri-award-line' },
  { year: '2026', titleKey: 'milestone7_title', descKey: 'milestone7_desc', icon: 'ri-heart-line' },
];

export default function Timeline() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="text-[#C8714A] text-xs font-semibold tracking-widest uppercase mb-3">
            {t('timeline_label')}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-3">{t('timeline_title')}</h2>
          <p className="text-[#888] text-sm max-w-md mx-auto">
            {t('timeline_desc')}
          </p>
        </div>

        <div className="relative">
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-px bg-[#f0ebe4] -translate-x-1/2"></div>

          <div className="flex flex-col gap-0">
            {milestones.map((item, i) => {
              const isLeft = i % 2 === 0;
              return (
                <div
                  key={item.year}
                  className={`relative flex flex-col lg:flex-row items-start lg:items-center gap-4 lg:gap-0 pb-10 ${
                    isLeft ? 'lg:flex-row' : 'lg:flex-row-reverse'
                  }`}
                >
                  <div className={`w-full lg:w-[calc(50%-2.5rem)] ${isLeft ? 'lg:pr-10 lg:text-right' : 'lg:pl-10'}`}>
                    <div className={`bg-[#faf8f5] rounded-2xl p-5 border border-[#f0ebe4] hover:border-[#C8714A]/30 transition-colors ${isLeft ? 'lg:ml-auto' : ''}`}>
                      <div className="flex items-center gap-2 mb-2 lg:hidden">
                        <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#C8714A]/10">
                          <i className={`${item.icon} text-[#C8714A] text-xs`}></i>
                        </div>
                        <span className="text-[#C8714A] text-sm font-black">{item.year}</span>
                      </div>
                      <div className={`hidden lg:flex items-center gap-2 mb-2 ${isLeft ? 'justify-end' : ''}`}>
                        <span className="text-[#C8714A] text-sm font-black">{item.year}</span>
                      </div>
                      <h3 className="text-base font-bold text-[#1a1a1a] mb-2">{t(item.titleKey)}</h3>
                      <p className="text-sm text-[#888] leading-relaxed">{t(item.descKey)}</p>
                    </div>
                  </div>

                  <div className="hidden lg:flex absolute left-1/2 -translate-x-1/2 w-10 h-10 items-center justify-center rounded-full bg-white border-2 border-[#C8714A] z-10">
                    <i className={`${item.icon} text-[#C8714A] text-sm`}></i>
                  </div>

                  <div className="hidden lg:block w-[calc(50%-2.5rem)]"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}